/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S20_Li4_DInputs */

const tr_mesafeli_s20_li4_d = /** @type {(inputs: Mesafeli_S20_Li4_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` adresinden yapılabilir.`)
};

const en_mesafeli_s20_li4_d = /** @type {(inputs: Mesafeli_S20_Li4_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

const de_mesafeli_s20_li4_d = /** @type {(inputs: Mesafeli_S20_Li4_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` gestellt werden.`)
};

const ru_mesafeli_s20_li4_d = /** @type {(inputs: Mesafeli_S20_Li4_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

/**
* | output |
* | --- |
* | "." |
*
* @param {Mesafeli_S20_Li4_DInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s20_li4_d = /** @type {((inputs?: Mesafeli_S20_Li4_DInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S20_Li4_DInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s20_li4_d(inputs)
	if (locale === "de") return de_mesafeli_s20_li4_d(inputs)
	if (locale === "ru") return ru_mesafeli_s20_li4_d(inputs)
	return tr_mesafeli_s20_li4_d(inputs)
});